import { useNavigation } from '@/contexts/NavigationContext';
import { useIsMobile } from '@/hooks/use-mobile';
import { ChatPage } from '@/pages/ChatPage';
import { PromptsPage } from '@/pages/PromptsPage';
import { AgentsPage } from '@/pages/AgentsPage';
import { ToolsPage } from '@/pages/ToolsPage';
import { AdminPage } from '@/pages/AdminPage';
import { PromptFormPage } from '@/pages/PromptFormPage';
import { AgentFormPage } from '@/pages/AgentFormPage';
import { ProjectSettingsPage } from '@/pages/ProjectSettingsPage';

export const MainContent = () => {
  const { navigation, sidebarCollapsed, editingResource, activeConversationId } = useNavigation();
  const isMobile = useIsMobile();

  const renderContent = () => {
    // If editing a resource, show the form page
    if (editingResource) {
      if (editingResource.type === 'prompt') return <PromptFormPage />;
      if (editingResource.type === 'agent') return <AgentFormPage />;
      if (editingResource.type === 'project-settings') return <ProjectSettingsPage />;
    }

    switch (navigation.tab) {
      case 'chat':
        // Chaveado por conversa: cada conversa tem sua própria montagem do
        // ChatPage (e portanto sua própria binding de useChat). Os Chats vivem
        // no GenerationRegistry, então trocar de conversa NÃO interrompe o
        // stream — ele segue em segundo plano. Ver docs/plano-streaming-concorrente.md.
        return <ChatPage key={activeConversationId ?? '__new__'} />;
      case 'prompts':
        return <PromptsPage />;
      case 'agents':
        return <AgentsPage />;
      case 'tools':
        return <ToolsPage />;
      case 'admin':
        return <AdminPage />;
      default:
        return <ChatPage key={activeConversationId ?? '__new__'} />;
    }
  };

  return (
    <div
      className={`flex-1 flex flex-col min-h-0 transition-all duration-300 ${
        !isMobile && !sidebarCollapsed ? 'ml-64' : 'ml-0'
      }`}
    >
      <div className="flex-1 flex flex-col overflow-hidden min-h-0">
        {renderContent()}
      </div>
    </div>
  );
};
